
$(document).ready(function(){
  if(window.focus == false)
  {
    this.focus();
  }
});
function sendEmail()
{

  var email = $("#Email_footer").val();
  
  if(email != undefined && email != "" || email != null)
  {

    var winGoogle =window.open("http://email.loungedoctor.com/public/?q=direct_add&fn=Public_DirectAddForm&id=amtceixxtuwrzlfopxjclnqyflgfbmc&email="+email+"&field3=msgpref,set,1&list4=LISTID&comment=WebSignUp", '_blank');
    $("#modal_button").click();
    window.focus();
   
    setTimeout(function(){
      winGoogle.close();
       $("#contact_form").submit
      $("#Email_footer").val(null);
      //location.reload();

    },1100);
    

  }
}

